import { Chip } from '@mui/material'
import { GeneratorElutionDto } from '@services/dtos'
import { ChipWastedStatus } from './ChipWastedStatus'

export const ChipGeneratorElutionStatus = ({ elution, withTooltip }: { elution: GeneratorElutionDto; withTooltip?: boolean }) =>
  elution.wasteEntry
    ? <ChipWastedStatus wasteEntry={elution.wasteEntry} withTooltip={withTooltip} />
    : <Chip
        label="Disponible"
        size="small"
        variant={'outlined'}
        sx={{ color: '#459464', borderColor: '#598c5bff' }}
      />
